
(function () {
    'use strict';

    angular.module('documentFieldsModule', [])
        .controller("DocumentFieldsController", documentFieldsController);

	documentFieldsController.$inject = ['$http', '$sce', '$timeout', '$location', '$scope', '$rootScope', '$anchorScroll',
        'documentService', 'anchorService', 'documentContentsSearchService', 'resizeService', '$stateParams', 'pubSub',
        'folderService', 'treeNavigationService', '$q', 'configService'];

	function documentFieldsController($http, $sce, $timeout, $location, $scope, $rootScope, $anchorScroll,
        documentService, anchorService, documentContentsSearchService, resizeService, $stateParams, pubSub,
        folderService, treeNavigationService, $q, configService) {
        var ignoreRichText = configService.getBool(HandbookConfiguration.LazyLoadRichText);

        var vm = this;

        vm.documentInformation = {};
        vm.originalData = {};
        vm.fieldId = -1;
        vm.currentData = {};
        vm.oldData = {};
        vm.highlights = {
            highlightText: '',
            currentIndex: 0,
            totalFound: 0
        };
        vm.FolderLinks = [];


        var urlParams = $location.url().split('/');
        vm.isEmbedUrl = false;
        vm.typeHideHeader = false;
        vm.documentId = $stateParams.documentId;

        vm.addFavoriteRequest = handbookRequests.AddFavoriteDocument;
        vm.removeFavoriteRequest = handbookRequests.RemoveFavoriteDocument;

        if (urlParams != null && urlParams.length > 0) {
            vm.isEmbedUrl = urlParams[1] == 'embed';
            if (vm.isEmbedUrl) {
                vm.fieldId = urlParams[5];
                vm.typeHideHeader = urlParams.length == 7 ? (urlParams[6] == '1') : false;
                vm.documentId = urlParams[3];
            }
        }
        vm.urlDocument = window.location.origin + '/document/' + vm.documentId + '?preview=true';
        vm.showDocumentLinkToBackend = configService.getBool(HandbookConfiguration.ShowDocumentLinkToBackend);
        vm.simpleSubscription = configService.getBool(HandbookConfiguration.SimpleSubscription);

        vm.isShowMetadata = configService.getBool(HandbookConfiguration.MetadataEnabled);
        vm.isShowMetatagTab = configService.getBool(HandbookConfiguration.ShowMetatagTab);
        vm.publishedVersion = configService.getBool(HandbookConfiguration.PublishedVersion);
        vm.showContent = showContent;
        vm.clearActive = clearActive;
        vm.searchAndHighlightText = searchAndHighlightText;
        vm.navForward = navForward;
        vm.navBackward = navBackward;
        vm.printDocumentField = printDocumentField;
        vm.fullScreen = fullScreen;
        vm.isFloatTitle = $(window).height() > HandbookConfiguration.DocumentTitleScreenHeight ? true : false;
        vm.linkToDocumentManagement = linkToDocumentManagement;
        vm.getNextSearchResultByEnter = getNextSearchResultByEnter;
        vm.documentViewOption = parseInt(HandbookConfiguration.DocumentViewOption);
        vm.isToggleSidebarFields = true;
        vm.showSidebarFields = showSidebarFields;
        vm.hideSidebarFields = hideSidebarFields;
        vm.compareDocument = compareDocument;
        vm.hideCompareButton = false;
        vm.documentCKVersion = CkVersion.CK4;
        vm.ckVersion = { 'CK4': CkVersion.CK4, 'CK5': CkVersion.CK5 };

        initialize();

        function initialize() {

            fullScreenInit();

            processEmbedUrl();
            //check and resize the view
            resizeService.resizeView();
            //get document info from service
            if (!vm.isEmbedUrl) {
                var currentDocument = documentService.getDocuments();

                if (currentDocument && currentDocument.documentInformation) {
                    vm.isFavoriteNodeSelected = true;
                    buildDocumentObjectFromCurrentDocument(currentDocument);
                    $rootScope.title = globalResources.Handbook + " - " + currentDocument.documentInformation.documentName;
                    angular.copy(vm.documentInformation, vm.originalData);
                    runServicesAfterInit();
                }
                else {
                    getDocument();
                }
                folderService.getFolderByVirtualDocumentId($stateParams.documentId).then(function (response) {
                    vm.FolderLinks = response.data;
                });
            } else {
                getDocument();
            }
            treeNavigationService.navigateToItemLocation(true);
        };

        function processEmbedUrl() {
            if (vm.isEmbedUrl) {
                if (vm.typeHideHeader) {
                    angular.element('#documentHeader1Container').hide();
                    angular.element('#fieldTitle').hide();
                }
            }
        }

        function linkToDocumentManagement() {
            var backendUrl = HandbookConfiguration.BackendURL;
            var lastChar = backendUrl.charAt(backendUrl.length - 1);
            var commonAdd = lastChar == '/' ? '' : '/';
            if (vm.backendIsDb4) {
                var url = backendUrl + '&documentId=' + vm.documentId;
                url = url.replace('gk=2', 'gk=1');
                window.open(url, '_blank');
            } else {
                window.open(backendUrl + commonAdd + 'document/' + vm.documentId, '_blank');
            }
        };

        function getDocument() {
            if (vm.isShowMetadata && vm.isShowMetatagTab) {
                getMetadataTab();
            }

            var params = {
                params: {
                    'documentId': vm.documentId,
                    'ignoreRichText': ignoreRichText,
                    showLoading: true
                }
            };
            vm.currentDataPromise =
                $http.get(handbookRequests.GetDocumentInformationRequest, params)
                    .then(function (result) {
                        vm.isFavoriteNodeSelected = true;
                        createTooltipsRelatedDocument(result.data);
                        vm.oldData = result.data;
                        vm.documentCKVersion = vm.oldData.isNewCKVersion;
                        if (vm.oldData.description) {
                            vm.oldData.description = $sce.trustAsHtml(vm.oldData.description.replace(new RegExp(String.fromCharCode(13) + String.fromCharCode(10), 'g'), '<br/>'));
                        }
                        vm.oldData.nodeType = convertToNodeType(vm.oldData.type);
                        if (vm.oldData.fieldContents != null) {

                            var richTextRequests = [];

                            vm.oldData.fieldContents.forEach(function (fieldContent) {
                                if (!vm.oldData.fieldId) {
                                    vm.oldData.fieldId = fieldContent.fieldId;
                                }

                                if (fieldContent.description) {
                                    fieldContent.description = $sce.trustAsHtml(fieldContent.description);
                                }

                                if (ignoreRichText && fieldContent.fieldType == 6 && fieldContent.fieldContentId) {
                                    var params = {
                                        params: {
                                            id: fieldContent.fieldContentId,
                                            documentId: vm.documentId
                                        }
                                    }

                                    var getRichText = $http.get('/api/documents/getRichText', params).then(function (response) {
                                        if (response.data && response.data.content) {
                                            fieldContent.content = documentService.changeUrlBackendToFrontend(window.location.origin, response.data.content);
                                            fieldContent.content = $sce.trustAsHtml(`${fieldContent.content} `);
                                            fieldContent.isVisible = true;
                                        }
                                    });

                                    richTextRequests.push(getRichText);
                                } else {
                                    if (fieldContent.content) {
                                        fieldContent.content = documentService.changeUrlBackendToFrontend(window.location.origin, response.data.content);
                                        fieldContent.content = $sce.trustAsHtml(`${fieldContent.content} `);
                                    }
                                }
                            });


                            if (ignoreRichText) {
                                $q.all(richTextRequests).then(function () {
                                    angular.copy(vm.oldData, vm.originalData);
                                    vm.oldData.documentInformation = angular.copy(vm.oldData);
                                    vm.oldData.confirmInformation = vm.currentData.confirmInformation;

                                    if (vm.isEmbedUrl) {
                                        vm.oldData.fieldId = vm.fieldId;
                                    } else {
                                        vm.oldData.fieldId = $stateParams.fieldId;
                                    }
                                    buildDocumentObjectFromCurrentDocument(vm.oldData);
                                    runServicesAfterInit();
                                });
                            }

                            updateFields();
                        }
                        if (vm.isShowMetadata && vm.isShowMetatagTab) {
                            vm.oldData.metadatas = angular.copy(vm.metadataList);
                            formatMetadata();
                        }

                        if (!ignoreRichText || !vm.oldData.fieldContents){
                            angular.copy(vm.oldData, vm.originalData);
                            vm.oldData.documentInformation = angular.copy(vm.oldData);
                            vm.oldData.confirmInformation = vm.currentData.confirmInformation;

                            if (vm.isEmbedUrl) {
                                vm.oldData.fieldId = vm.fieldId;
                            } else {
                                vm.oldData.fieldId = $stateParams.fieldId;
                            }
                            buildDocumentObjectFromCurrentDocument(vm.oldData);
                            runServicesAfterInit();
                        }

                        documentService.setDocuments(null); // clear service
                        vm.showDocumentLinkToBackend = vm.showDocumentLinkToBackend &&
							(vm.oldData.hasEditPermission || vm.oldData.hasApprovalPermission);

                        vm.isCompare = configService.getBool(HandbookConfiguration.EnableCompare) && vm.oldData.version > 0;
                        if (vm.currentData.type == E.documentTypes.LinkDocument || vm.currentData.type == E.documentTypes.FileDocument) {
                            vm.hideCompareButton = true;
                        }
                        $rootScope.title = globalResources.Handbook + " - " + result.data.documentName;
                        return vm.currentData;
                    })
                    .catch(function (result) {
                        vm.errorMessage = result.data;
                        vm.showError = true;
                        // Update currentData so favorite button work
                        vm.currentData.documentId = vm.documentId;
                        runErrorServicesAfterInit();
                    });
        };

        function getMetadataTab() {
            $http.get(handbookRequests.GetDocumentMetadataRequest, { params: { 'documentId': $stateParams.documentId } })
                .then(function (result) {
                    vm.metadataList = result.data;
                });
        };

        function formatMetadata() {
            if (vm.isShowMetadata && vm.oldData.metadatas && vm.oldData.metadatas.length > 0 && vm.isShowMetatagTab) {
                vm.oldData.metadatas.forEach(function (item) {
                    item.nameDisplay = $sce.trustAsHtml(item.registerName + ' - ' + item.registerItemName + ' - ' + item.registerValue);
                });
            }
        }

        function updateFields() {
            var relatedDocumentAll = angular.copy(vm.oldData.relatedDocuments);
            var relatedAttachmentAll = angular.copy(vm.oldData.relatedAttachments);

            vm.oldData.isShowTopBoxContent = false;

            for (var i = 0; i < vm.oldData.fieldContents.length; i++) {
                var fieldContent = vm.oldData.fieldContents[i];
                if (checkShowFieldName(fieldContent)) {
                    vm.oldData.isShowTopBoxContent = true;
                }

                var relatedDocuments = fieldContent.relatedDocuments;
                relatedDocumentAll = relatedDocumentAll.concat(relatedDocuments);

                var relatedAttachments = fieldContent.relatedAttachments;
                relatedAttachmentAll = relatedAttachmentAll.concat(relatedAttachments);

                var relatedImageGroups = groupBy(fieldContent.images, function (item) {
                    return [item.verticalAlign];
                });
                var relatedBottomImages = [];
                var relatedTopImages = [];
                relatedImageGroups.forEach(function (item) {
                    if (item.key == parseInt(E.VerticalAlign.Top)) {
                        relatedTopImages = relatedTopImages.concat(item.value.data);
                    } else {
                        if (item.key == parseInt(E.VerticalAlign.Bottom)) {
                            relatedBottomImages = relatedBottomImages.concat(item.value.data);
                        }
                    }
                });
                fieldContent.relatedTopImages = relatedTopImages;
                fieldContent.relatedBottomImages = relatedBottomImages;
            }
        };

        function checkShowFieldName(fieldContent) {
			if (fieldContent.fieldName != '' && fieldContent.fieldName != undefined && fieldContent.isVisible && !fieldContent.isHideByBooklet) {
                return true;
            }
            return false;
        }

        function convertToNodeType(documentType) {
            switch (documentType.toString()) {
                case E.documentTypes.Document:
                    return E.nodeTypes.Document;
                case E.documentTypes.LinkDocument:
                    return E.nodeTypes.LinkDocument;
                case E.documentTypes.FileDocument:
                    return E.nodeTypes.FileDocument;
                case E.documentTypes.ShortcutDocument:
                    return E.nodeTypes.ShortcutDocument;
            }
        }

        function setIconForDocument(data) {
            data = data == null ? vm.currentData : data;
            var icon = '';
            switch (data.levelType.toString()) {
                case E.HandbookLevelTypes.Enterprise:
                    icon = paths.DocumentLevelTypeEnterprise;
                    break;
                case E.HandbookLevelTypes.Regional:
                    icon = paths.DocumentLevelTypeRegional;
                    break;
                case E.HandbookLevelTypes.Local:
                    icon = paths.DocumentLevelTypeLocal;
                    break;
                default:
                    icon = paths.DocumentLevelTypeEnterprise;
                    break;
            }
            data.docIcon = icon;
        }

        function buildDocumentObjectFromCurrentDocument(currentDocument) {
            if (currentDocument) {
                vm.documentInformation = angular.copy(currentDocument.documentInformation);
                vm.currentData = angular.copy(currentDocument.documentInformation);
                setIconForDocument(vm.documentInformation);
                if (vm.currentData.description) {
                    vm.currentData.description = $sce.trustAsHtml(vm.currentData.description.toString());
                }
                if (vm.isShowMetadata && vm.currentData.metadatas && vm.currentData.metadatas.length > 0 && vm.isShowMetatagTab) {
                    vm.currentData.metadatas.forEach(function (item) {
                        item.nameDisplay = $sce.trustAsHtml(item.nameDisplay.toString());
                    });
                }
                if (vm.documentInformation) {
                    for (var i = 0; i < vm.documentInformation.fieldContents.length; i++) {
                        if (vm.documentInformation.fieldContents[i].fieldId == currentDocument.fieldId) {
                            vm.fieldId = currentDocument.fieldId;
                            vm.currentData.confirmInformation = currentDocument.confirmInformation;
                            vm.documentInformation.fieldContents[i].activeField = 'active';
                            if (vm.documentInformation.fieldContents[i].fieldName) {
                                vm.documentInformation.fieldName = $sce.trustAsHtml(vm.documentInformation.fieldContents[i].fieldName.toString());
                            }
                            if (vm.documentInformation.fieldContents[i].content) {
                                vm.documentInformation.content = $sce.trustAsHtml(vm.documentInformation.fieldContents[i].content.toString());
                            }
                            vm.documentInformation.relatedDocuments = vm.documentInformation.fieldContents[i].relatedDocuments;
                            vm.documentInformation.relatedAttachments = vm.documentInformation.fieldContents[i].relatedAttachments;

                            vm.documentInformation.relatedTopImages = vm.documentInformation.fieldContents[i].relatedTopImages;
                            vm.documentInformation.relatedBottomImages = vm.documentInformation.fieldContents[i].relatedBottomImages;
                        }
                        else {
                            vm.documentInformation.fieldContents[i].activeField = '';
                        }
                    }
                }
            }
        };

        function showContent(fieldItem, type) {
            vm.clearActive();
            if (fieldItem) {
                fieldItem.activeField = 'active';
                if (fieldItem.fieldName) {
                    vm.documentInformation.fieldName = $sce.trustAsHtml(fieldItem.fieldName);
                }
                if (fieldItem.content) {
                    vm.documentInformation.content = $sce.trustAsHtml(fieldItem.content.toString());
                } else {
                    vm.documentInformation.content = '';
                }
                vm.documentInformation.relatedDocuments = fieldItem.relatedDocuments;
                vm.documentInformation.relatedAttachments = fieldItem.relatedAttachments;
                vm.documentInformation.relatedTopImages = fieldItem.relatedTopImages;
                vm.documentInformation.relatedBottomImages = fieldItem.relatedBottomImages;
                vm.fieldId = fieldItem.fieldId;
                angular.copy(vm.documentInformation, vm.originalData);
                updateLocalAnchors();
            } else {
                clearDocumentInformation();
                if (type == 0) {
                    vm.activeRelatedDocuments = true;
                    vm.documentInformation.relatedDocuments = vm.currentData.relatedDocuments;
                } else {
                    vm.activeAttachments = true;
                    vm.documentInformation.relatedAttachments = vm.currentData.relatedAttachments;
                }
            }
        };

        $scope.$watch('vm.documentInformation.fieldName', function (newValue, oldValue) {
            pubSub.publish(broadcastType.loadContentFieldDone, { fieldName: newValue });
        });

        function clearDocumentInformation() {
            vm.documentInformation.fieldName = '';
            vm.documentInformation.content = '';
            vm.documentInformation.relatedDocuments = null;
            vm.documentInformation.relatedAttachments = null;
            vm.documentInformation.relatedTopImages = null;
            vm.documentInformation.relatedBottomImages = null;
        }

        function clearActive() {

            vm.activeRelatedDocuments = false;
            vm.activeAttachments = false;

            for (var i = 0; i < vm.documentInformation.fieldContents.length; i++) {
                vm.documentInformation.fieldContents[i].activeField = '';
            }
        };

        function searchAndHighlightText() {
            highlightTextInContent();
            documentContentsSearchService.searchAndHighlightText(vm.highlights);
        };

        function navForward() {
            documentContentsSearchService.navForward(vm.highlights);
        };

        function navBackward() {
            documentContentsSearchService.navBackward(vm.highlights);
        };

        function printDocumentField() {
            window.open(String.format(handbookRequests.PrintHtmlFieldRequest, vm.documentInformation.documentId, vm.fieldId));
        };

        function highlightTextInContent() {
            if (vm.documentInformation.content != undefined) {
                angular.copy(vm.originalData, vm.documentInformation);
                vm.documentInformation.content = documentContentsSearchService.searchAndHighlight(vm.documentInformation.content, vm.highlights.highlightText);
            }
        };

        function updateLocalAnchors() {
            $timeout(function () {
                var domContent = angular.element('div.contentWithLayout');
				anchorService.updateLocalAnchors(domContent, true);
				scrollToAnchorIfExists();
            });
        }

		function scrollToAnchorIfExists() {
			var hash = $location.hash();
			if (hash != '') {
				$anchorScroll();
			}
		}

        function runServicesAfterInit() {
            updateLocalAnchors();
        }

        function fullScreen() {
            if (vm.isFullScreen) {
                documentService.showFullscreen();
            } else {
                documentService.showNormal();
            }
            vm.isFullScreen = !vm.isFullScreen;
        }

        function fullScreenInit() {
            if (angular.element('#handbook-nav:visible').length == 0) {
                documentService.showFullscreen();
                vm.isFullScreen = false;
            } else {
                documentService.showNormal();
                vm.isFullScreen = true;
            }
        }

        $scope.$on(broadcastType.toggleDocumentFullscreen, function (e, target) {
            fullScreen();
        });

        function anchorClick(hash) {
            if (vm.documentInformation.fieldContents.length == 1)
                return;
            var existedAnchor = false;
            var domContent = angular.element('div.contentWithLayout');
            angular.forEach(domContent.find('a[name]'), function (tag) {
                if (hash.hash.indexOf(tag.attributes.name.value) != -1) {
                    existedAnchor = true;
                }
            });
            if (existedAnchor)
                return;

            if (hash.hash.indexOf('AndreEH%C3%A5ndboksdokumenter') != -1) {
                if (vm.currentData.relatedDocuments.length > 0) {
                    showContent(null, 0);
                }
                return;
            }
            if (hash.hash.indexOf('vedlegg') != -1) {
                if (vm.currentData.relatedAttachments.length > 0) {
                    showContent(null, 1);
                }
                return;
            }
            var field = null;
            for (var i = 0; i < vm.documentInformation.fieldContents.length; i++) {
                var fieldContent = vm.documentInformation.fieldContents[i];
                if (fieldContent.fieldId == vm.fieldId || !fieldContent.content) {
                    continue;
                }

                var div = document.createElement('div');
                div.innerHTML = fieldContent.content;
                domContent = angular.element(div);
                angular.forEach(domContent.find('a[name]'), function (tag) {
                    if (hash.hash.indexOf(tag.attributes.name.value) != -1) {
                        existedAnchor = true;
                    }
                });
                if (existedAnchor) {
                    field = fieldContent;
                    break;
                }
            }
            if (field != null) {
                showContent(field);
            }
        }

        function getNextSearchResultByEnter(keyEvent) {
            if (keyEvent.which == 13) {
                navForward();
            }
        }

        $scope.$on('anchorclick', function (e, target) {
            anchorClick(target);
        });

        function showSidebarFields() {
            vm.isToggleSidebarFields = true;
        }

        function hideSidebarFields() {
            vm.isToggleSidebarFields = false;
		}

		function compareDocument() {
			window.open(String.format('/document/{0}/compareWithEarlierVersion', vm.documentId), '_blank');
		}
    };

})();